<script setup lang="ts">
import type { AsideModel } from '@su4r-frontend/api';

defineProps<{
    data: AsideModel;
}>();

const localeRoute = useLocaleRoute();
const { data: authData } = useAuth();
const routes = useTranslatedRoutes();
</script>

<template>
    <div class="tile tile-blur">
        <div class="flex flex-col gap-4">
            <h3 v-if="data.title" class="font-title text-xl">{{ data.title }}</h3>
            <div v-if="data.body" v-html="data.body" />

            <NuxtLink
                v-if="data.link && authData?.user.role === 'practitioner'"
                class="btn-primary-b"
                :to="localeRoute(routes.prescribe)"
                :target="data.link.openInNewTab ? '_blank' : '_self'"
                >{{ $t('interventionOverview.viewDetailsButtonTextPractitioner') }}</NuxtLink
            >
            <NuxtLink
                v-else-if="data.link"
                class="btn-primary-b"
                :to="localeRoute(data.link.url)"
                :target="data.link.openInNewTab ? '_blank' : '_self'"
                >{{ data.link.title }}</NuxtLink
            >
        </div>
    </div>
</template>
